import React from 'react';
import ToggleOption from './ToggleOption';
import ProfileSection from '../../components/ProfileSection';
import { getShipperBranding, getShipperName } from '../../utils';
import CompanyBranding from './CompanyBranding';
import { useShipperDetails } from './hooks';

/**
 * The Details tab of a shipper's profile: the carrier's settings for this shipper, and the
 * shipper's branding.
 * @param {{ partnership: Object, notify: Function }} props
 */
const DetailsPage = ({ partnership, notify }) => {
    const details = useShipperDetails(partnership, notify);
    const branding = getShipperBranding(partnership);

    return (
        <>
            <ProfileSection title="Details">
                <ToggleOption
                    checked={details.shareManifests}
                    onChange={details.setShareManifests}
                    disabled={details.savingManifests}
                    label="Share warehouse manifest information with this shipper."
                />
                <ToggleOption
                    checked={details.orderCompletedEmail}
                    onChange={details.setOrderCompletedEmail}
                    disabled={details.savingEmail || details.shipperOwnsEmail}
                    label="Email this shipper when an order of theirs is completed"
                    hint={
                        details.shipperOwnsEmail ? 'The shipper manages this in their own account settings.' : undefined
                    }
                />
            </ProfileSection>
            <ProfileSection title="Company Branding">
                <CompanyBranding {...branding} name={getShipperName(partnership)} />
            </ProfileSection>
        </>
    );
};

export default DetailsPage;
